module.exports = __webpack_public_path__ + "static/media/Export_Icon_White.320c96ef.svg";